// extracted by mini-css-extract-plugin
export var fullHeightState = "_4b-7";
export var headerCell = "_4b-1";
export var loadingStateCell = "_4b-4";
export var rowWrapper = "_4b-3";
export var standaloneTable = "_4b-8";
export var standaloneTableWithBodyFill = "_4b-9";
export var stateCell = "_4b-5";
export var table = "_4b-0";
export var tableBodyFiller = "_4b-6";
export var white = "_4b-2";